import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { CardData } from '../../../../models/print-cards/card-data';
import { ShelfTalkerCardData } from '../../../../models/shelf-talkers/shelf-talker-card-data';
import { CardsThatLayoutOntoPaper } from '../../../../models/menu/section/cards-that-layout-onto-paper';

@Component({
  selector: 'app-page-of-cards',
  templateUrl: './page-of-cards.component.html',
  styleUrl: './page-of-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PageOfCardsComponent {
  @Input() cardsAsData: CardData[] | ShelfTalkerCardData[];
  @Input() layoutInstructions: CardsThatLayoutOntoPaper;
}
